import React from 'react'
import { TEMPLATES } from '../../../../constants/watermark'
import * as WM from '../../typings'

const WatermarkCover: React.FC<WM.WatermarkCoverProps> = ({ watermark }) => {
  const content: WM.WatermarkContent | null | undefined =
    watermark.watermarkContent
  if (content) {
    return (
      <div className="watermark-item">
        <div className="title">
          <p>{content.name}</p>
        </div>
        <div className="footer">
          {TEMPLATES.find((template) => template.id === content.base_id)?.name}
        </div>
        {watermark.isDraft && <span className="draft">未发布</span>}
      </div>
    )
  }
  return (
    <div className="watermark-item">
      <div className="title">
        <p style={{ color: '#FF0000' }}>数据错误</p>
      </div>
      <div className="footer">
        {TEMPLATES.find((template) => template.id === watermark.baseID)?.name}
      </div>
    </div>
  )
}

export default WatermarkCover